import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHomePage = location.pathname === '/';

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || !isHomePage
            ? 'bg-white shadow-md'
            : 'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="text-xl md:text-2xl font-bold text-blue-900">
              おかやま国際人材派遣株式会社
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              <Link
                to="/services"
                className={`font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHomePage
                    ? 'text-gray-700 hover:text-blue-900'
                    : 'text-white hover:text-orange-300'
                }`}
              >
                事業内容
              </Link>
              <Link
                to="/about"
                className={`font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHomePage
                    ? 'text-gray-700 hover:text-blue-900'
                    : 'text-white hover:text-orange-300'
                }`}
              >
                会社概要
              </Link>
              <Link
                to="/careers"
                className={`font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHomePage
                    ? 'text-gray-700 hover:text-blue-900'
                    : 'text-white hover:text-orange-300'
                }`}
              >
                求人情報
              </Link>
              <Link
                to="/blog"
                className={`font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHomePage
                    ? 'text-gray-700 hover:text-blue-900'
                    : 'text-white hover:text-orange-300'
                }`}
              >
                お知らせ
              </Link>
            </nav>

            <div className="hidden lg:flex items-center gap-4">
              <a
                href="tel:086-012-3456"
                className={`flex items-center gap-2 font-semibold transition-colors whitespace-nowrap ${
                  isScrolled || !isHomePage
                    ? 'text-green-600 hover:text-green-700'
                    : 'text-white hover:text-green-300'
                }`}
              >
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-phone-fill text-white"></i>
                </div>
                <span>086-012-3456</span>
              </a>
              <Link
                to="/contact"
                className="bg-blue-900 hover:bg-blue-800 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap"
              >
                お問い合わせ
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
                isScrolled || !isHomePage ? 'text-blue-900' : 'text-white'
              }`}
            >
              <i className={`text-3xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-blue-900 z-40 lg:hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="flex flex-col items-center justify-center h-full gap-8 px-4">
          <Link
            to="/services"
            className="text-white text-2xl font-semibold hover:text-orange-300 transition-colors whitespace-nowrap"
          >
            事業内容
          </Link>
          <Link
            to="/about"
            className="text-white text-2xl font-semibold hover:text-orange-300 transition-colors whitespace-nowrap"
          >
            会社概要
          </Link>
          <Link
            to="/careers"
            className="text-white text-2xl font-semibold hover:text-orange-300 transition-colors whitespace-nowrap"
          >
            求人情報
          </Link>
          <Link
            to="/blog"
            className="text-white text-2xl font-semibold hover:text-orange-300 transition-colors whitespace-nowrap"
          >
            お知らせ
          </Link>
          <a
            href="tel:086-012-3456"
            className="flex items-center gap-3 text-white text-2xl font-semibold hover:text-green-300 transition-colors whitespace-nowrap"
          >
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
              <i className="ri-phone-fill text-white text-xl"></i>
            </div>
            <span>086-012-3456</span>
          </a>
          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-full text-xl font-semibold transition-all duration-300 whitespace-nowrap"
          >
            お問い合わせ
          </Link>
        </nav>
      </div>
    </>
  );
}
